'use strict';

(function (angular) {
    angular.module('zp').service('SlugerService', slugerService);

    /** @ngInject */
    function slugerService() {

        var service = this;

        service.generateSlug = generateSlug;

        ///////////////////////////////////////////////

        var transliterationRules = [{ key: 'š', value: 's' }, { key: 'đ', value: 'dj' }, { key: 'č', value: 'c' }, { key: 'ć', value: 'c' }, { key: 'ž', value: 'z' }, { key: '?', value: '' }];

        function generateSlug(text) {
            var almostCompleteSlug = text.replace(/ /g, '-').toLowerCase();
            var slug = '';
            for (var i = 0; i < almostCompleteSlug.length; i++) {
                slug += transliterateCharacter(almostCompleteSlug[i]);
            }
            return slug;
        }

        function transliterateCharacter(character) {
            for (var i = 0; i < transliterationRules.length; i++) {
                if (transliterationRules[i].key === character) {
                    return transliterationRules[i].value;
                }
            }
            return character;
        }
    }
})(window.angular);